import { Paper } from '@mui/material'
import CreateWorkspaceFormBody from './CreateWorkspaceFormBody.jsx'
import styles from './CreateWorkspace.module.scss'

export default function CreateWorkspaceCard({ form, onSubmit, submitLabel = 'Create workspace' }) {
  return (
    <Paper className={styles.card} elevation={0} component="form" onSubmit={onSubmit}>
      <CreateWorkspaceFormBody
        form={form}
        submitLabel={submitLabel}
        showHeading
        heading="Create your workspace"
      />
    </Paper>
  )
}
